export class InvalidCertificationPassRequirementError extends Error {
    constructor(passReq: string) {
        super(`${passReq} is not a valid certification pass requirement`);
    }
}
